import { gql } from '@/__generated__/gql';

export const INVESTOR_DETAILS_COMMITMENTS_TAB_TABLE_DATA_QUERY = gql(`
  query InvestorDetailsCommitmentsTabTableData($id: String!, $includeRecommendation: Boolean, $sort: String, $order: PaginateSortDirection, $search: String, $group: Boolean) {
    ClientEntityDetailsCommitments(id: $id, includeRecommendation: $includeRecommendation, sort: $sort, order: $order, search: $search, group: $group) {
      commitments {
        id
        investmentId
        name
        entityName
        committedCapital
        capitalCalled
        capitalRemaining
        distributionsToDate
        marketValue
        status
        assetClass {
          id
          name
        }
        subAssetClass {
          id
          name
        }
        moreInfo {
          id
          managerId
          assetClass
          nextClose
          finalClose
          investorDocsDue
          minimum
          custodied
          ubtiBlocker
          targetIRR
          targetYield
        }
        valuationAmount
        valuationDate
        aggregateCallsAndDistributions
      }
    }
  }
`);

export const INVESTOR_DETAILS_HOUSEHOLD_COMMITMENTS_TAB_TABLE_DATA_QUERY = gql(`
  query InvestorDetailsHouseholdCommitmentsTabTableData($data: InvestorHouseholdCommitmentsInput!) {
    investorHouseholdCommitments(data: $data) {
      total
      page
      perPage
      limit
      offset
      lastPage
      totals {
        capitalCalled
        capitalCalledPercentage
        capitalRemaining
        committedCapital
        distributionsToDate
        marketValue
      }
      commitments {
        id
        investmentId
        name
        entityName
        committedCapital
        capitalCalled
        capitalRemaining
        distributionsToDate
        marketValue
        status
        assetClass {
          id
          name
        }
        subAssetClass {
          id
          name
        }
        moreInfo {
          id
          managerId
          assetClass
          nextClose
          finalClose
          investorDocsDue
          minimum
          custodied
          ubtiBlocker
          targetIRR
          targetYield
        }
        valuationAmount
        valuationDate
        aggregateCallsAndDistributions
      }
    }
  }
`);
